import { lonamic } from 'lonamic'

const roles = {
  superadmin: {
    can: ['user:add'],
    inherits: ['signingAuthority']
  },
  signingAuthority: {
    can: ['cheque:approve'],
    inherits: ['bookkeeper']
  },
  bookkeeper: {
    can: ['cheque:upload']
  }
}

async function getACL () {
  const acl = lonamic(roles)
  return acl
}

export default getACL



// WEBPACK FOOTER //
// ./src/Private/acl.js